export const STONE_HARBOR = {
  name: "Stone Harbor",
  latitude: 39.0509,
  longitude: -74.7577,
  timeZone: "America/New_York",
  nwsForecastZoneId: "NJZ024",
  tideStationId: "8535581",
  tideStationName: "Stone Harbor, Great Channel"
} as const;

export function formatInStoneHarbor(iso: string, options: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: STONE_HARBOR.timeZone,
    ...options
  }).format(new Date(iso));
}

export function localDateKey(iso: string): string {
  return formatInStoneHarbor(iso, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
}
